<!-- <form autocomplete="off" class="p-0" novalidate [formGroup]="SctHist">
    
    <div class="col-lg-12 col-md-12">

        <div class="card custom-card">
            <div class="card-body">
                <div class="card-body pl-1">
                   
                        margindotted 
                        <div class="col-sm-12 ">
                            <h6 class="main-content-label f10">
                                 {{selectedoption}}
                                Scrutiny History
                            </h6>

                            
                        </div>
                    
                </div>
            </div>
        </div>
    </div>
</form> -->
<div class="row row-sm add-form">
    <form [formGroup]="SctHist" autocomplete="off" class="p-0" novalidate>
        <div class="card-body">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <!-- <div class="card-body"> -->
                <!-- <div class="card custom-card"> -->
                <div class="col-sm-12 text-center">
                    <h4 class="mt-2"> Scrutiny History</h4>
                </div>
                <!-- <div class="bc d-flex align-items-center  pl-3">
                                <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                                <div class="ml-2 text-center">
                                    <h3 class="main-content-label mb-1 mt-2 "><b>
                                        Scrutiny History
                                        </b></h3>
                                    <p class="text-muted card-sub-title mb-0">
                                        {{'header.faculty-data.titleList.AddNewFacultyInformation' | translate}}
                                    </p>
                                </div>
                            </div> -->
                <div class="row clearfix">
                    <div class="table-responsive mt-4 widthTb">
                        <table id="datatable" class="table  table-bordered text-nowrap text-left">
                            <thead>
                                <tr class="text-left">
                                    <th class="f600">
                                        Scrutiny Date & Time
                                    </th>
                                    <th class="f600">
                                        Scrutiny By
                                    </th>
                                    <th class="f600">
                                        Scrutiny Comments
                                    </th>
                                    <th class="f600">
                                        Status
                                    </th>
                                    <!-- <th class="f600">
                                        Scrutiny Level
                                    </th> -->

                                </tr>
                            </thead>
                            <tbody id="table_data">
                                <!-- examSemList formArrayName="SctArray"-->
                                <tr *ngFor="let scrutiny of ScrutinyTable;">
                                    <!--  -->
                                    <td>
                                        {{ convertUTCToIST(scrutiny.dateTime) }} 
                                        <!-- {{scrutiny.dateTime | date:'dd/MM/yyyy'}} {{scrutiny.dateTime | date:'h:mm:ssa':'Asia/Kolkata'}} -->
                                    </td>
                                    <td *ngIf="scrutiny.Status != 'BCKP'">
                                        <!-- {{scrutiny.ScrutinyLevel == 1 ? 'Student: ' + scrutiny.Status : scrutiny.LoginFullName}} -->
                                        {{ getLoginFullName(scrutiny.StudentId, scrutiny.Status) }}
                                    </td>
                                    <td *ngIf="scrutiny.Status == 'BCKP'">
                                        {{scrutiny.LoginFullName}}
                                       
                                    </td>
                                    <!-- <td>
                                        {{ getLoginFullName(scrutiny.StudentId, scrutiny.Status) }}
                                    </td> -->

                                    <!-- {{ getLoginFullName(scrutiny.StudentId, scrutiny.Status) }} -->
                                    <td>
                                        {{scrutiny.Comment}}
                                    </td>
                                    <td>
                                        {{scrutiny.Status}}
                                    </td>
                                    <!-- <td>
                                        {{scrutiny.ScrutinyLevel == 0 ? 0 : scrutiny.ScrutinyLevel-1}}
                                    </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-sm-2 offset-sm-10">

                        <!-- <button type="button"
                                    class="btn btn-primary my-2 me-2 mt-0 btn-icon-text floatright btn-raised g-bg-blush2"
                                    (click)="close()">
                                  
                                        Close
                                  
                                </button> -->
                        <!-- <div class="col-sm-2 pri-0" > -->
                        <button type="button" class="btn btn-primary btn-icon-text floatright mt-1" (click)="close()">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/img/letter-x.gif" style="margin-right: 5px;">
                                Close
                            </span>
                        </button>
                        <!-- </div> -->

                    </div>
                </div>
                <!-- </div> -->
                <!-- </div> -->

            </div>
        </div>
    </form>
</div>